import Button from "./Button";
import { useLocation } from "react-router-dom";

// const appURL = "/task-tracker";

const Header = ({ appURL, onShowAddTask, showAddTask }) => {
  const location = useLocation();
  return (
    <header className="header">
      <h1>Task Tracker</h1>
      {location.pathname === appURL + "/" && (
        <Button
          text={showAddTask ? "Hide" : "Show"}
          background={showAddTask ? "grey" : "green"}
          onClick={onShowAddTask}
        />
      )}
    </header>
  );
};

export default Header;
